import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { StringHelper } from "../../../../../../../../../react-core/Helpers/StringHelper";
import { CurrencyCode } from "../../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { TransactionSummary } from "../../../../../../../../../Wrap/Models/Domains/Transactions/Summary/TransactionSummary";
import { Table } from "../../../../../../../../Shared/Table/Table";

interface ISummaryTableProps {
    data: Array<TransactionSummary>;
}

export const SummaryTable = (props: ISummaryTableProps) => {
    const stringHelper = new StringHelper();
    return (
        <div>
            <Table
                data={props.data}
                rowCssWrapper={"product-heading"}
                col={[
                    {
                        title: "Product",
                        key: "ClAccountId",
                        render: (data, row, index) => {
                            return (
                                <>
                                    <span
                                        aria-hidden="true"
                                        className={"product-legend " + stringHelper.getDonutClass(row.ProductType, row.WrapperSubType)}
                                    ></span>
                                    <span className={stringHelper.getDonutClass(row.ProductType, row.WrapperSubType) + "-text"}>
                                        {row.ProductDisplayName}
                                    </span>
                                    <span className="account">{data}</span>
                                </>
                            );
                        },
                    },
                    {
                        title: "Money in",
                        key: "MoneyInAmount",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                    },
                    {
                        title: "Withdrawals",
                        key: "WithdrawalsAmount",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                    },
                    {
                        title: "Charges",
                        key: "ChargesAmount",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                    },
                ]}
                TotalBody={[
                    { data: "Portfolio total" },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.MoneyInAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.WithdrawalsAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.ChargesAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                ]}
            ></Table>
        </div>
    );
};
